/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_IndexesInputs */

const en_svchip_indexes = /** @type {(inputs: Svchip_IndexesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indexes`)
};

const ar_svchip_indexes = /** @type {(inputs: Svchip_IndexesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفهارس`)
};

const bn_svchip_indexes = /** @type {(inputs: Svchip_IndexesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইন্ডেক্স`)
};

const de_svchip_indexes = /** @type {(inputs: Svchip_IndexesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indizes`)
};

const es_svchip_indexes = /** @type {(inputs: Svchip_IndexesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Índices`)
};

const fr_svchip_indexes = /** @type {(inputs: Svchip_IndexesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Index`)
};

const pt_svchip_indexes = /** @type {(inputs: Svchip_IndexesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Índices`)
};

const zh_svchip_indexes = /** @type {(inputs: Svchip_IndexesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`索引`)
};

const tr_svchip_indexes = /** @type {(inputs: Svchip_IndexesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dizinler`)
};

const ru_svchip_indexes = /** @type {(inputs: Svchip_IndexesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Индексы`)
};

const pl_svchip_indexes = /** @type {(inputs: Svchip_IndexesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indeksy`)
};

/**
* | output |
* | --- |
* | "Indexes" |
*
* @param {Svchip_IndexesInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_indexes = /** @type {((inputs?: Svchip_IndexesInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_IndexesInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_indexes(inputs)
	if (locale === "bn") return bn_svchip_indexes(inputs)
	if (locale === "de") return de_svchip_indexes(inputs)
	if (locale === "es") return es_svchip_indexes(inputs)
	if (locale === "fr") return fr_svchip_indexes(inputs)
	if (locale === "pt") return pt_svchip_indexes(inputs)
	if (locale === "zh") return zh_svchip_indexes(inputs)
	if (locale === "tr") return tr_svchip_indexes(inputs)
	if (locale === "ru") return ru_svchip_indexes(inputs)
	if (locale === "pl") return pl_svchip_indexes(inputs)
	return en_svchip_indexes(inputs)
});